import { useEffect, useState } from "react";
import { api, track } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import SEO from "@/components/SEO";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function RestaInContatto() {
  const [form, setForm] = useState({ nome: "", email: "", telefono: "", marketing_consent: false });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  useEffect(() => { track("page_view", "resta-in-contatto"); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.marketing_consent) { toast.error("Per iscriverti è necessario dare il consenso."); return; }
    setLoading(true);
    try {
      await api.post("/contacts", { ...form, source: "sito-fidelizzazione" });
      toast.success("Grazie! Resterai in contatto con Masetti.");
      setForm({ nome: "", email: "", telefono: "", marketing_consent: false });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Si è verificato un errore.");
    } finally { setLoading(false); }
  };

  return (
    <div>
      <SEO title="Resta in contatto" description="Iscriviti per ricevere le serate, i menu speciali e le novità dalla cucina del Ristorante Masetti." />
      <div className="min-h-[80vh] flex items-center justify-center bg-cream-dark py-16">
        <div className="max-w-md w-full mx-auto px-6">
          <div className="text-center mb-8">
            <Mail className="w-9 h-9 mx-auto text-brass mb-3" />
            <h1 className="font-serif text-3xl sm:text-4xl text-bordeaux">Resta in contatto con Masetti</h1>
            <p className="font-accent italic text-lg text-oak/75 mt-3">Ricevi le nostre serate, i menu speciali e le novità dalla cucina.</p>
          </div>
          <form onSubmit={submit} className="space-y-4 bg-white p-6 rounded-2xl border border-brass/20" data-testid="newsletter-form">
            <div><Label className="text-xs uppercase tracking-wider text-oak/70">Nome *</Label><Input required value={form.nome} onChange={(e) => set("nome", e.target.value)} data-testid="nl-nome" /></div>
            <div><Label className="text-xs uppercase tracking-wider text-oak/70">Email *</Label><Input type="email" required value={form.email} onChange={(e) => set("email", e.target.value)} data-testid="nl-email" /></div>
            <div><Label className="text-xs uppercase tracking-wider text-oak/70">Telefono / WhatsApp</Label><Input value={form.telefono} onChange={(e) => set("telefono", e.target.value)} data-testid="nl-telefono" /></div>
            <label className="flex items-start gap-3 text-sm text-oak/75 cursor-pointer">
              <Checkbox checked={form.marketing_consent} onCheckedChange={(v) => set("marketing_consent", !!v)} data-testid="nl-consent" className="mt-0.5" />
              <span>Acconsento a ricevere comunicazioni marketing dal Ristorante Masetti (eventi, menu speciali, novità). Potrò revocare il consenso in qualsiasi momento.</span>
            </label>
            <Button type="submit" disabled={loading} className="w-full bg-bordeaux hover:bg-bordeaux-dark text-cream" data-testid="nl-submit">{loading ? "Invio…" : "Iscrivimi"}</Button>
            <p className="text-[11px] text-oak/50 text-center">Trattiamo i tuoi dati nel rispetto del GDPR. Nessuna casella è preselezionata.</p>
          </form>
        </div>
      </div>
    </div>
  );
}
